const profileStorageKeys = {
  socialVerifications: 'social-verifications' as const,
  verificationPending: 'verification-pending' as const,
} as const;

export {profileStorageKeys};
